import * as yup from 'yup';

const groupFormSchema = yup.object().shape({
  name: yup.string().required('accessGroupsNameRequired'),
  usersInThisGroup: yup.array().min(1, 'accessGroupsUsersRequired').required('accessGroupsUsersRequired'),
});

export default groupFormSchema;
